// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"dcb2f83c","990":"4cd64931"}[chunkId] + ".chunk.js";
};